import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, SecurityStatement } from 'common/components/layout';
import { getCustomer } from 'redux/customer/actions';

import Questions from './Questions';
import CreateAccount from './components/CreateAccount';
import ReturningCustomerForgot from './components/ReturningCustomerForgot';

class ForgotPassword extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings, location } = this.props;
    let redirectTo = '/profile';
    if (location && location.state && location.state.redirectLink) {
      redirectTo = location.state.redirectLink;
    }
    if (!settings.data) {
      return (
        <Layout title="Forgot Password" loading>
          <Title>Forgot Password</Title>
        </Layout>
      );
    }
    return (
      <Layout title="Forgot Password">
        <Title>Forgot Password</Title>
        <div className="c7-account-login">
          <ReturningCustomerForgot redirectLink={redirectTo} />
          <CreateAccount settings={settings} />
        </div>
        <SecurityStatement settings={settings} />
        <Questions settings={settings} />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(ForgotPassword);
